import type { LandingTestimonialPublic } from '@repo/api-contracts';
import type { ReactElement } from 'react';

interface CompanyCaseCardProps {
  readonly item: LandingTestimonialPublic;
}

/**
 * 기업 고객 사례 카드 — 위에 사진, 아래 제목·본문(여섯 줄까지)·담당자. 운영자가 랜딩 관리에서 등록한다.
 * 링크는 없다(상품 후기가 아니라 기업과 함께한 제작 사례 소개).
 */
export const CompanyCaseCard = ({ item }: CompanyCaseCardProps): ReactElement => (
  <article className="flex h-full min-w-0 flex-col bg-background">
    <div className="aspect-[4/3] w-full overflow-hidden bg-muted/70">
      <img src={item.imageUrl} alt="" loading="lazy" className="size-full object-cover" />
    </div>
    <div className="flex flex-1 flex-col gap-3 pt-5">
      <h3 className="text-base font-bold tracking-[-0.01em] sm:text-lg">{item.title}</h3>
      <p className="line-clamp-6 text-sm leading-relaxed text-muted-foreground whitespace-pre-line">
        {item.body}
      </p>
      <p className="mt-auto pt-3 text-xs font-medium text-foreground">{item.author}</p>
    </div>
  </article>
);
